import Glide from "@glidejs/glide";

export default () => ({
  init() {
    this.initSliders();
  },

  /**
   * Init All Corporate Sliders (PageIntro, Insights)
   */
  initSliders() {
    const sliders = document.querySelectorAll(".corporate-news.glide");

    if (!sliders) {
      return;
    }

    sliders.forEach((slider) => {
      const activeBullet = "glide__bullet--active";
      const activeSlideCounter = slider.querySelector(".glide__counter");
      const bulletsContainerElement = slider.querySelector(".glide__bullets");

      const changeActiveBullet = (newIndex, containerElement) => {
        const glideDir = containerElement.querySelector(
          `[data-glide-dir="=${newIndex}"]`
        );

        containerElement
          .querySelector(`.${activeBullet}`)
          .classList.remove(activeBullet);

        if (glideDir) {
          glideDir.classList.add(activeBullet);

          if (activeSlideCounter) {
            activeSlideCounter.innerHTML =
              parseInt(
                glideDir.getAttribute("data-glide-dir").replace(/=/g, "")
              ) + 1;
          }
        }
      };

      const glide = new Glide(slider, {
        type: "carousel",
        animationDuration: 1000,
        perView: 1,
      }).mount();

      glide.on("run", () => {
        requestAnimationFrame(() =>
          changeActiveBullet(glide.index, bulletsContainerElement)
        );
      });
    });
  },
});
